import React, { useEffect, useState } from "react";
import { Box, Button, Typography  } from "@mui/material";
import HoaOnboardingDetailsModal from "./hoa-onboarding-details-modal";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import OnboardingSteps from "./on-boarding-steps";
import datastore from "../../store/hoa-datastore";

export default function HoaOnboardingView({ onboardingDataState }:any) {
    const [isCompleted, setIsCompleted] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeState, setActiveState] = useState(1);
    const handleModalClose = () => {
        setIsModalOpen(false);
    }

    const onViewDetailsBtnClicked = () => {
        setActiveState(1);
        setIsModalOpen(true);
    }

    const nextBtnClicked = () => {
        setActiveState(activeState != 4 ? activeState + 1 : activeState);
    }

    const previousBtnClicked = () => {
        setActiveState(activeState != 1 ? activeState - 1 : activeState);
    }

    useEffect(() => {
        let completed = true;
        for (const key of Object.keys(onboardingDataState)) {
            if (!onboardingDataState[key].isCompleted) {
                completed = false;
            }
        }

        setIsCompleted(completed);
    }, [onboardingDataState]);

    return (
        <div style={{ borderBottom: "1px solid #E8E8E8", }}>
            <HoaOnboardingDetailsModal
                isModalOpen={isModalOpen} 
                handleModalClose={handleModalClose} 
                activeState={activeState}
                isEditMode={false}
                onboardingDataState={onboardingDataState}
                nextBtnClicked={nextBtnClicked}
                previousBtnClicked={previousBtnClicked}
            />
            <div style={{ background: '#FAFAFA', padding: '16px', border: '1px solid #E8E8E8', borderRadius: '4px' }}>
                <div style={{ display: 'flex', justifyContent: "space-between" }}>
                    <div style={{ width: '80%', display: 'flex' }}>
                          {
                            datastore.isUserPermitted('HOA', 'view', 'HOA_ONBOARDING') && isCompleted && <div style={{ 
                            display: "flex", 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            height: isCompleted ? '42px' : '40px', 
                            width: isCompleted ? '42px' : '40px',
                            borderRadius: '50%', 
                            border: isCompleted ? "" : '2px solid #3576E5', 
                            color: isCompleted ? "#FFFFFF" : "#383838", 
                            fontWeight: '500',
                            background: isCompleted ? "#538AE9" : "#F2F2F2"
                        }}>
                                <DoneAllIcon />
                        </div>}
                        <div style={{ 
                            display: "flex", 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            paddingLeft: '10px', 
                            color: "#303030", 
                            fontWeight: '500' 
                        }}>
                            {
                                isCompleted ?
                            <>{datastore.isUserPermitted('HOA', 'view', 'HOA_ONBOARDING') ? `HOA has been onboarded` : `HOA Onboarding & Verification Completed`} | Onboarding Date: {(onboardingDataState?.clientDirectory?.onboardingDate === '' || !onboardingDataState?.clientDirectory?.onboardingDate) ? 'N/A': onboardingDataState?.clientDirectory?.onboardingDate?.replace(/\./g, '/')}</>
                                :
                                <>
                                {onboardingDataState["callHoa"].isCompleted ? <OnboardingSteps onboardingDataState={onboardingDataState} isCompleted={onboardingDataState["callHoa"].isCompleted} isActive={activeState == 4} stateNumber={4} stateName={"Call HOA"}/> : onboardingDataState["emailHoa"].isCompleted ?
                                                            <OnboardingSteps onboardingDataState={onboardingDataState} isCompleted={onboardingDataState["emailHoa"].isCompleted} isActive={activeState == 3} stateNumber={3} stateName={"Email HOA"}/> : onboardingDataState["portalSearch"].isCompleted ?
                                  <OnboardingSteps onboardingDataState={onboardingDataState} isCompleted={onboardingDataState["portalSearch"].isCompleted} isActive={activeState == 2} stateNumber={2} stateName={"Portal Search"}/> : onboardingDataState["clientDirectory"].isCompleted ?
                                
                                <OnboardingSteps onboardingDataState={onboardingDataState} isCompleted={onboardingDataState["clientDirectory"].isCompleted} isActive={activeState == 1} stateNumber={1} stateName={"Client's Directory"}/> : (<Box sx={{display: 'flex', alignItems: "center", gap: "8px"}}>  <div style={{ 
                                    display: "flex", 
                                    justifyContent: 'center', 
                                    alignItems: 'center', 
                                    height: '24px', 
                                    width: '24px',
                                    borderRadius: '50%', 
                                    border: '2px solid #3576E5', 
                                    color: "#383838", 
                                    fontWeight: '500',
                                    background: "#F2F2F2"
                                }}>
                                <PriorityHighIcon sx={{fontSize: "small"}} />
                                </div>
                                <Typography sx={{color: "#303030", fontWeight: "500"}}>No onboarding steps have been completed.</Typography>
                        </Box>)}
                                </>
                            }
                        </div>
                    </div>
                    {datastore.isUserPermitted('HOA', 'view', 'HOA_ONBOARDING') && <Button
                        style={{
                            width: '20%',
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#3E3E3E",
                            background: "#FFFFFF",
                            borderRadius: "4px",
                            border: "1px solid #E8E8E8"
                        }}
                        onClick={onViewDetailsBtnClicked}
                    >
                        View Onboarding
                    </Button>}
                </div>
            </div>
        </div>
    )
}